// src/components/VetsSection.js
import React from 'react';
import './VetsSection.css';

// Import the necessary images
import teamPhoto from '../assets/teamPhoto.png';
import decorativePets from '../assets/kitten-puppy.png';

const VetsSection = () => {
  return (
    <section className="vets-section">
        <h2 className="section-title">
          Meet Our <span className='highlight'>Vets</span>
        </h2>
        
        <div className="vets-intro-box">
          <img 
            src={decorativePets} 
            alt="Decorative kitten and puppy" 
            className="decorative-pets-img" 
          />
          <h3>
            Team of India’s-Renowned <span className='highlight'>Veterinary Experts </span>Who Truly Care
          </h3>
          {/* <p>
            Experienced vets specialized in small animal care, diagnosis, and treatment, with expertise in nutrition guidance and surgical assistance.
          </p> */}
      </div>

      <div className="">
          <img src={teamPhoto} alt="Dr. Doodley Team" className="team-photo" />
      </div>
    </section>
  );
};

export default VetsSection;